import moment from 'moment';

import { HoursOfOperation, Time } from '../../entity/hours-of-operation';
import { AddressTransformer, StateTransformer } from '../transformers/address';
import { CoordinateTransformer } from '../transformers/coordinate';


import { EVCStation } from '../../entity/location/evcstation';
import { EVCBayOutlet, EVCBayOutletGun, EVCStationBaySetup, EVCStationBayStatus, EVCBayOutletTariff } from "../../entity/station/evcbay";
import { StationTransformer } from './evcstation';
import { EVChargerTransformer } from './evcharger';
import { EVChargeTariff } from '../../entity/station/evcharge-tariff';
import { EVChargerOutput } from '@/entity/station/evcharger';

export class EVCStationBaySetupTransformer {
    transform(baySetupInfo: any): EVCStationBaySetup {
        let outlets: EVCBayOutlet[] = []
        let outletsInfos: any[] = baySetupInfo.charger.outputs
        if(outletsInfos) {
            outletsInfos.forEach(outletInfo => {
                let guns: EVCBayOutletGun[] = []
                let outletGunsInfos: any[] = outletInfo.ports
                outletGunsInfos.forEach(outletGunInfo => {
                    guns.push(new EVCBayOutletGun(
                        outletGunInfo.portId, outletGunInfo.name
                    ))
                });
                let tariffs: EVCBayOutletTariff[] = []
                let outletTariffs: any[] = outletInfo.tariffDetails
                outletTariffs.forEach(outletTariff => {
                    tariffs.push(new EVCBayOutletTariff(
                        outletTariff.chargerInstallationTariffId, 
                        outletTariff.tariffCode, 
                        moment(outletTariff.effectiveFrom, moment.ISO_8601).toDate(), 
                        moment(outletTariff.effectiveTo, moment.ISO_8601).toDate()
                    ))
                });


                outlets.push(new EVCBayOutlet(
                    outletInfo.name,
                    outletInfo.name,
                    {
                        id: outletInfo.outputId,
                        number: outletInfo.outputNumber
                    } as any,
                    guns,
                    new EVChargeTariff(outletInfo.tariffCode, outletInfo.tariffCode),
                    tariffs,
                    outletInfo.qrCodeValue,
                    outletInfo.cmsTagNo
                ))                
            });
        }
        return new EVCStationBaySetup(
            baySetupInfo.installationId,
            baySetupInfo.station ? new StationTransformer().transform(baySetupInfo.station) : baySetupInfo.stationId,
            baySetupInfo.charger ? new EVChargerTransformer().transform(baySetupInfo.charger) : baySetupInfo.chargerId,
            outlets,
            new EVCStationBayStatus(baySetupInfo.status.code, baySetupInfo.status.description),
            moment(baySetupInfo.effectiveFrom, moment.ISO_8601).toDate(),
            moment(baySetupInfo.effectiveTo, moment.ISO_8601).toDate()
        )
    }

    deTransform(baySetup: EVCStationBaySetup): any {
        let outlets = baySetup.outlets
        let outletsInfos: any[] = [] 
        outlets.forEach(outlet => {
            let gunsInfos: any[] = []
            let guns = outlet.guns
            guns.forEach(gun => {
                gunsInfos.push({
                    portId: gun.id,
                    name: gun.name
                })
            });
            let outputTariffInfo: any[] = []
            let outputTariffs = outlet.tariffs
            outputTariffs.forEach(oTariff => {
                outputTariffInfo.push({
                    chargerInstallationTariffId: oTariff.id,
                    tariffCode: oTariff.tariffCode,
                    effectiveFrom : oTariff.effectiveOn ? oTariff.effectiveOn.toISOString() : null,
                    effectiveTo : oTariff.effectiveTill ? oTariff.effectiveTill.toISOString() : null
                })
            });

            outletsInfos.push({
                outputId: outlet.output.id,
                outputNumber: outlet.output.number,
                name: outlet.name,
                tariffDetails : outputTariffInfo,
                gunDetails: gunsInfos,
                qrCodeValue: outlet.qrCodeValue,
                cmsTagNo: outlet.cmsTagNo
            })
        });     
        let baySetupInfo: any = {}        
        if(baySetup.id) {
            baySetupInfo = { ...baySetupInfo,
                installationId: baySetup.id
            }            
        
        }
        //if(baySetup.effectiveOn) console.log("Effective Date Before and After Conversion On: ",baySetup.effectiveOn, baySetup.effectiveOn.toISOString() );        
        //if(baySetup.effectiveTill) console.log("Effective Date Before and After Conversion Till: ",baySetup.effectiveTill, baySetup.effectiveTill.toISOString() );        
        baySetupInfo = { ...baySetupInfo,            
            station: {
                stationId: baySetup.station.id
            },
            charger: {
                chargerId: baySetup.charger.id
            },
            effectiveFrom: baySetup.effectiveOn ? baySetup.effectiveOn.toISOString() : null,
            effectiveTo: baySetup.effectiveTill ? baySetup.effectiveTill.toISOString() : null,
            status: {
                code: baySetup.status.id
            },
            bayDetails: outletsInfos
        }
        return baySetupInfo
    }
}